const accessTokens = {
  admin: 'admin-accessToken',
  editor: 'editor-accessToken',
  test: 'test-accessToken',
}

module.exports = [
   {
    url: '/api/pre_upload/api/upload/files',
    type: 'post',
    response() {
      return {
        success: true,
        code: 1000,
        msg: '操作成功',
        data: [
          {
            alt: 'bccd69cef6d5010d6119a19f6d013ccc.jpg',
            file_path: '/20240429/ed6e1892-4474-4a54-a82e-6f2021cd7be3.jpg',
          },
        ],
      }
    },
  },
  {
    url: '/login',
    type: 'post',
    response() {
      const accessToken = 'test-accessToken'

      return {
        success: true,
        code: 1000,
        msg: '操作成功',
        data: {
          accessToken,
          exp: 11709634896,
          token: 'xxxxxxxxxxxxxxxxxxxxxxxxxxx',
        },
      }
    },
  },
  {
    url: '/token/refresh',
    type: 'post',
    response() {
      return {
        success: true,
        code: 1000,
        msg: '操作成功',
        data: {
          exp: 1806532235,
          token:
            'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJleHAiOjE3MDY1MzIyMzUsInN1YiI6Imp3dCIsIm5iZiI6MTcwNjUyODYzNSwiYXVkIjoidXNlciIsImlhdCI6MTcwNjUyODYzNSwianRpIjoiZDNhM2QyOGFiMTk2YmFkZWNhYWYyNTUxZGE5OWI0ZDIiLCJpc3MiOiJ2cnMiLCJzdGF0dXMiOjEsImRhdGEiOnsidXNlcl9pZCI6IjEwMCIsInVzZXJfbmFtZSI6Iui_kOe7tOi0puaItyIsImFjY291bnQiOiJ5aXNhIiwiZ2VuZGVyIjowLCJyb2xlTGlzdCI6W10sInBlcm1pc3Npb25MaXN0IjpbXX19.U1a_PAqwOy5ZuWCEreE7jwYCgbOIlj-lUIuzrqVRVzo',
        },
      }
    },
  },
  {
    url: '/config/get',
    type: 'post',
    response() {
      return {
        success: true,
        code: 1000,
        msg: '',
        data: {
          publicKey:
            '-----BEGIN PUBLIC KEY-----\r\nMIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDAEPqQ7aXgbNSWni0WTizuNijG\r\nXmTK3X3Xi3feaNIuRPMz0Z3R8/dBJtmnk7hxFSggsW1RVaW8Ry3T8aM32YXLv3u/\r\nd3JrWk6kv8eSHUvOZle77vBc7T68fKub4y4HnRE9Vvtp+o8Hxm5+z+SgVETbIMd/\r\nDAzUbqtpxSW+4AmAjQIDAQAB\r\n-----END PUBLIC KEY-----',
        },
      }
    },
  },
  {
    url: '/socialLogin',
    type: 'post',
    response(config) {
      const { code } = config.body
      if (!code) {
        return {
          code: 500,
          msg: '未成功获取Token。',
        }
      }
      return {
        code: 1000,
        msg: 'success',
        data: { accessToken: accessTokens['admin'] },
      }
    },
  },
  {
    url: '/register',
    type: 'post',
    response() {
      return {
        code: 1000,
        msg: '模拟注册成功',
      }
    },
  },

  {
    url: '/user/info',
    type: 'post',
    response() {
      return {
        code: 1000,
        msg: 'success',
        data: {
          user_id: '100',
          user_name: '运维账户',
          account: 'yisa',
          gender: 0,
          roleList: [
            {
              role_id: '828757906454216704',
              code: 'admin',
            },
          ],
          permissionList: [
            {
              permission_id: '828763026348834816',
              code: 'sys:manage',
            },
          ],
        },
      }
    },
  },
  {
    url: '/userInfo',
    type: 'post',
    response(config) {
      const { accessToken } = config.body
      let roles = ['admin']
      let ability = ['READ']
      let username = 'admin'
      if ('admin-accessToken' === accessToken) {
        roles = ['admin']
        ability = ['READ', 'WRITE', 'DELETE']
        username = 'admin'
      }
      if ('editor-accessToken' === accessToken) {
        roles = ['editor']
        ability = ['READ', 'WRITE']
        username = 'editor'
      }
      if ('test-accessToken' === accessToken) {
        roles = ['admin', 'editor']
        ability = ['READ']
        username = 'test'
      }
      return {
        code: 1000,
        msg: 'success',
        data: {
          roles,
          ability,
          username,
          'avatar|1': [
            'https://i.gtimg.cn/club/item/face/img/2/15922_100.gif',
            'https://i.gtimg.cn/club/item/face/img/8/15918_100.gif',
          ],
        },
      }
    },
  },
  {
    url: '/logout',
    type: 'post',
    response() {
      return {
        code: 1000,
        msg: 'success',
      }
    },
  },
]
